import { useLayoutEffect, useState } from 'react'

export const useOnload = () => {
  const [onload, setOnload] = useState(false)

  useLayoutEffect(() => {
    const onLoadHandler = () => {
      setOnload(true)
    }

    window.addEventListener('load', onLoadHandler)
    return () => window.removeEventListener('load', onLoadHandler)
  }, [])

  return onload
}